import type {ValueOf} from '@myparcel-frontend/types';
import {SubscriptionStatus} from '@/types/subscriptions';

export const isSubscriptionPending = (status: ValueOf<typeof SubscriptionStatus>): boolean =>
  status === SubscriptionStatus.Pending;

export const isSubscriptionStartingSoon = (status: ValueOf<typeof SubscriptionStatus>): boolean =>
  status === SubscriptionStatus.StartingSoon;

export const isSubscriptionTrialActive = (status: ValueOf<typeof SubscriptionStatus>): boolean =>
  status === SubscriptionStatus.TrialActive;

export const isSubscriptionTrialEnded = (status: ValueOf<typeof SubscriptionStatus>): boolean =>
  status === SubscriptionStatus.TrialEnded;

export const isSubscriptionEnded = (status: ValueOf<typeof SubscriptionStatus>): boolean =>
  status === SubscriptionStatus.Ended;

export const isSubscriptionEndingSoon = (status: ValueOf<typeof SubscriptionStatus>): boolean =>
  status === SubscriptionStatus.EndingSoon;

export const isSubscriptionActive = (status: ValueOf<typeof SubscriptionStatus>): boolean =>
  status === SubscriptionStatus.Active;
